import classnames from 'classnames';
import * as React from 'react';

import styles from './index.module.scss';

type PropsT = {
  className?: string;
  children: React.ReactNode;
};

export class CSATChromePreview extends React.PureComponent<PropsT> {
  render() {
    const { className, children } = this.props;
    const rootClassName = classnames({
      [styles.root]: true,
      className,
    });

    return (
      <div className={rootClassName}>
        <div className={styles.preview}>{children}</div>
      </div>
    );
  }
}
